import { Row } from '../../../../../components/Basic/Blocks';
import { TextGrey } from '../../../../../components/Basic/WrapsStyle';
import { TO_ENTRY, TO_RESERVE, TO_SUPPLY } from '../../../../../constans';
import { formFullDate } from '../../../../../utils';
import styles from './styles.module.scss';

const ACTION = {
  add: 'добавил(а)',
  add_return: 'внес(ла) c возвратов',
  add_overage: 'внес(ла) c излишек',
  add_entrying: 'внес(ла)',
  debit: 'списала(а)',
  reserve: 'зарезервировал(а)',
  dereserve: 'дерезервировал(а)',
  write_off: 'списал(а) для резерва', //списать с резерева
  write_off_supply: 'списал(а) для поставки', //списать с резерева
  confirm_return: 'закрыла(а) внесение', //закрытие резерва
  hand_reserve: 'зарезервировал(а) вручную',
  change_place: 'сменил(а) место c ', //списать с резерева
  add_inventory: 'добавил(а)',
  debit_inventory: 'списала(а)',
  debit_overage: 'уменьшил(а) излишек при внесении на ',
  debit_return: 'уменьшил(а) возврат на ',
  debit_entrying: 'уменьшил(а) внесение на ',
  express_reserve: 'зарезервировала в экпресс',
  write_off_express: 'списала в эксресс',
  change_ip: 'сменил(а) закупочное ИП ',
  confirm_inventory: 'завершил(а) инвентаризацию',
  express_dereserve: 'дерезезервировала экспресс',
};

const WarehouseHistoryBlock = ({ part, ...props }) => {
  let flag = [
    'add_overage',
    'debit_overage',
    'add_return',
    'add_entrying',
    'debit_entrying',
    'debit_return',
    'debit_entrying',
  ].includes(part.action);

  return (
    <Row>
      <span
        style={{
          whiteSpace: 'pre',
          color: flag ? 'grey' : 'auto',
        }}
      >
        <TextGrey>{formFullDate(part.date)}</TextGrey> {` `} <b>{part.user}</b>
        {` `}
        {ACTION[part.action]}
        {(part.action === 'change_place' || part.action === 'change_ip') && (
          <span style={{ color: 'rgb(138 22 6)', fontWeight: 600, fontSize: '17px' }}>{part.reason}</span>
        )}
        {['confirm_inventory'].includes(part.action) && `,  текущий остаток ${part.remains}`}
        {` `}
        <b>{part.quantity}</b>{' '}
        {['add', 'debit', 'write_off_express'].includes(part.action) && ` всего на складе ${part.remains}`}
        {['add_inventory', 'debit_inventory'].includes(part.action) && ` всего на складе ${part.inventory_remains}`}
        {['add_return', 'confirm_return', 'add_overage', 'add_entrying'].includes(part.action) && (
          <>
            {part.reserve_id && (
              <>
                ( Внесение -{' '}
                <a href={TO_ENTRY(part.reserve_id)} target={'_blank'} className={styles.link_blue}>
                  №{part.reserve_id}
                </a>{' '}
                )
              </>
            )}
          </>
        )}
        {['reserve', 'dereserve', 'write_off', 'express_reserve'].includes(part.action) && (
          <>
            всего в резерве {part.reserved}
            {part.reserve_id && (
              <>
                {'    '}(Резерв -{' '}
                <a href={TO_RESERVE(part.reserve_id)} target={'_blank'} className={styles.link_blue}>
                  №{part.reserve_id}
                </a>{' '}
                )
              </>
            )}
          </>
        )}
        {['write_off_supply'].includes(part.action) && (
          <>
            {part.reserve_id && (
              <>
                ( поставки -{' '}
                <a href={TO_SUPPLY(part.reserve_id)} target={'_blank'} className={styles.link_blue}>
                  №{part.reserve_id}
                </a>{' '}
                )
              </>
            )}
          </>
        )}

        {[
          'reserve',
          'dereserve',
          'write_off',
          'add',
          'debit',
          'add_return',
          'hand_reserve',
          'confirm_return',
          'add_inventory',
          'debit_inventory',
          'confirm_inventory',
          'add_overage',
          'add_entrying',
          'debit_overage',
          'debit_return',
          'debit_entrying',
          'express_reserve',
          'write_off_express',
          'write_off_supply',
          'express_dereserve',
        ].includes(part.action) && (
            <TextGrey style={{ marginLeft: '15px' }} fontWeight={500} fontSize={16}>
              [
              {part.inventory && (
                <>
                  инвентаризация:{' '}
                  <span
                    style={
                      part.inventory_remains > 0
                        ? { color: '#06168a', fontWeight: 600, fontSize: '16px' }
                        : { color: 'blue' }
                    }
                  >{`${part.inventory_remains || 0} `}</span>{' '}
                  /{' '}
                </>
              )}
              остаток:{' '}
              <span
                style={part.remains > 0 ? { color: '#06168a', fontWeight: 600, fontSize: '16px' } : { color: 'blue' }}
              >{`${part.remains} `}</span>{' '}
              / резерв:{' '}
              <span
                style={part.remains > 0 ? { color: '#0f8d1a', fontWeight: 600, fontSize: '16px' } : { color: 'green' }}
              >{`${part.reserved} `}</span>
              / занесение:{' '}
              <span
                style={
                  part.entry_processing > 0
                    ? { color: '#7c0f8d', fontWeight: 600, fontSize: '16px' }
                    : { color: '#7c0f8d' }
                }
              >{`${part.entry_processing || 0} `}</span>
              ]
            </TextGrey>
          )}
        {(part.reason || '').length > 0 && part.action !== 'change_place' && part.action !== 'change_ip' && (
          <TextGrey style={{ color: '#ff0000d6', fontStyle: 'italic', marginLeft: '5px' }}>{part.reason}</TextGrey>
        )}
        {part.inventory && (
          <TextGrey style={{ color: 'red', fontStyle: 'italic', marginLeft: '5px' }}> (Инвентаризация)</TextGrey>
        )}
        {part.posting_number?.length > 0 && (
          <TextGrey style={{ color: '#2600ff', fontStyle: 'italic', marginLeft: '5px' }}>
            заказ: {part.posting_number}
          </TextGrey>
        )}
      </span>
    </Row>
  );
};

export default WarehouseHistoryBlock;
